import React, { useState } from 'react';
import Logo from '../assets/images/logo.png';
import { Button, Card, Col, Form, Input, Row, message } from 'antd';
import { useDispatch } from 'react-redux';
import { login } from '../store/actions/authenticate';

export default function Login() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = (value) => {
    setIsLoading(true);
    dispatch(
      login(value, (error) => {
        message.error(error.error?.response?.data?.message || 'Something went wrong!');
        setIsLoading(false);
      }),
    );
  };

  return (
    <div className="login-page">
      <Row align="middle" justify="center" className="wrapper">
        <Col xs={24} sm={12} md={8} className="login-form">
          <Card>
            <img className="logo" alt="PETstock New Zealand logo" src={Logo} />
            <Form
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ remember: true }}
              className="form-content"
              onFinish={onFinish}
            >
              <Form.Item
                label="Username"
                name="username"
                labelAlign="left"
                rules={[{ required: true, message: 'Please input your username!' }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                labelAlign="left"
                label="Password"
                name="password"
                rules={[{ required: true, message: 'Please input your password!' }]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                wrapperCol={{ offset: 8, span: 16 }}
                className="d-flex justify-content-between"
              >
                <Row justify="space-between" align="middle">
                  <Button loading={isLoading} size="large" htmlType="submit">
                    Continue
                  </Button>
                  <a href="/request-reset-password" className="btn-reset-password">
                    Reset Password
                  </a>
                </Row>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
